export class BankAccount {
	Iban:string = "";
	Bic:string = "";

	public constructor(data:any){
		this.Iban = data.Iban;
		this.Bic = data.Bic;
	}
}